import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PtoEmision } from '../models/PtoEmision';

@Injectable({
    providedIn: 'root'
})
export class PtoEmisionService {

    private readonly ptoEmisionUrl = environment.ptoEmisionUrl;

    constructor(private readonly httpClient: HttpClient) {
    }

    getAllPtoEmision(): Observable<PtoEmision[]> {
        console.log(this.ptoEmisionUrl);
        return this.httpClient.get<PtoEmision[]>(this.ptoEmisionUrl);
    }

    getPartsPtoEmision(): Observable<PtoEmision[]> {
      console.log(this.ptoEmisionUrl);
      return this.httpClient.get<PtoEmision[]>(this.ptoEmisionUrl + "/parts");
    }
}
